import React from "react";
import { AlertIcon } from "../icons/alert-icon";

type ErrorAlertProps = {
  message: React.ReactNode;
};

export const ErrorAlert = ({ message }: ErrorAlertProps) => {
  if (!message) return null;
  return (
    <div className="bg-[#E50000]/50 border border-[#E50000] rounded-xl p-2 text-white flex items-center mb-4">
      <AlertIcon className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 lg:w-6 lg:h-6 mr-3 flex-shrink-0" />
      <span className="text-base font-medium">{message}</span>
    </div>
  );
};
